<template>
  <div>
    <div class="justify-content-between d-flex mb-4">
      <div class="d-flex align-items-center">
        <div class="filter refresh">
          <span>Refresh</span>
          <img src="./../assets/icons/arrow-down.svg" alt="" />
        </div>
        <div class="filter calendar" @click="toggleFilter">
          <img src="./../assets/icons/calendar.svg" alt="" />
          <span>Today</span>
          <img src="./../assets/icons/arrow-down.svg" alt="" />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <span>Show</span>
        <div class="filter show">
          <slot name="select-entry"></slot>
        </div>
        <slot name="entries-no"></slot>
      </div>
    </div>
    <div
      id="filterModal"
      class="filter-modal"
      :class="{ 'filter-fade': showFilterModal }"
    >
      <div class="filter-param">
        <span>Date</span>
        <!-- <slot name="choose-date" :closeModal="toggleFilter"></slot> -->
        <div class="d-flex">
          <b-form-datepicker
            placeholder="Start date"
            locale="en"
            class="filter-date mr-4"
            :max="today"
            @input="
              enableEndDate();
              applyFilter();
            "
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="
              applyFilter();
              toggleFilter();
            "
            v-model="endDate"
          ></b-form-datepicker>
        </div>
      </div>
    </div>
    <slot name="table"></slot>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      showFilterModal: false,
      startDate: "",
      endDate: "",
      disabled: true,
      today: new Date().toISOString().slice(0, 10),
    };
  },
  methods: {
    toggleFilter() {
      this.showFilterModal = !this.showFilterModal;
    },
    ...mapActions({
      topPinpad: "topAgents/getTopPinpad",
      topPos: "topAgents/getTopPos",
      topTransfer: "topAgents/getTopTransfer",
      topAccount: "topAgents/getTopAccount",
    }),
    applyFilter() {
      if (this.endDate.length > 1) {
        this.topPinpad({
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.topPos({
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.topTransfer({
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.topAccount({
          startDate: this.startDate,
          endDate: this.endDate,
        });
      }
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
  },
  created() {
    console.log(this.endDate.length);
    this.topPinpad({
      startDate: this.today,
      endDate: this.today,
    });
    this.topPos({
      startDate: this.today,
      endDate: this.today,
    });
    this.topTransfer({
      startDate: this.today,
      endDate: this.today,
    });
    this.topAccount({
      startDate: this.today,
      endDate: this.today,
    });
  },
};
</script>

<style lang="scss" scoped>
.filter-modal {
  width: fit-content;
}
.calendar img {
  padding: 0.65rem;
}
</style>
